module.exports = __webpack_public_path__ + "img/clear@2x.b7d56a5e.png";